import {
  Button as ButtonAntd,
  Card as CardAntd,
  Col,
  Form as FormAntd,
  Row as RowAntd,
  Spin as SpinAntd,
  Steps as StepsAntd,
  Switch as SwitchAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .height-71 {
    min-height: 74vh;
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  h3.ant-typography {
    font-size: 20px;
    color: #676A6C;
    margin-top: 40px;
  }

  .ant-spin-nested-loading, .ant-spin-container{
    height: 100%;
  }
`;

export const Steps = styled(StepsAntd)`
  padding: 24px 0;

  .ant-steps-item-title,
  .ant-steps-icon {
    font-weight: bold;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    border-bottom: dashed rgba(36, 169, 93, 1);
    border-radius: unset;
    background-color: unset;
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    border: 1px solid rgba(36, 169, 93, 1);
    background-color: rgba(36, 169, 93, 1);
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon {
    color: #fff !important;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    background-color: #fff;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85) !important;
    margin: 0 2px;
  }

  .ant-steps .ant-steps-item-finish .ant-steps-icon,
  .ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: rgba(36, 169, 93, 1) !important;
    top: -2px;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: #fff;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: rgba(36, 169, 93, 1);
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: rgba(36, 169, 93, 1) !important;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #24a95d;
  }
`;

export const StepContent = styled.div`
  background-color: #efefef;
  height: 92%;
`;

export const Form = styled(FormAntd)`
  /* height: 100%; */
`;

export const Title = styled(TypographyAntd.Title)`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 22px !important;
  color: #000000 !important;
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 24px;
  }
`;

export const ColCard = styled(Col)`
  padding: 24px 30px;
`;

export const Footer = styled(RowAntd)`
  margin-top: 10px;
  background: #ffffff;
  border-radius: 3px;
  padding: 17px 24px;
  margin: 0 30px !important;
`;

export const SpinAllSize = styled(SpinAntd)`
  min-height: 100% !important;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  padding: 5px 16px 5px 16px;
  border: 1px solid #24a95d;
  border-radius: 2px !important;
  background: #24a95d;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    border-color: #25b663;
    background-color: #25b663;
  }
`;

export const VoltarButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000;
  padding: 5px 16px 5px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px !important;
  background: #ffffff;

  &:hover,
  &:focus {
    color: #000000;
  }
`;

export const Switch = styled(SwitchAntd)`
  &[aria-checked='true'] {
    background-color: #24a95d;
  }

  &[aria-checked='false'] {
    background-color: #e2e2e2;
  }
`;
